export default function authHeader() {
    const user = localStorage.getItem('user');
    console.log(user);
    if (user) {
        return { headers: { "Authorization": "Bearer " + user } };
    } else {
        return "";
    }
}